import { Injectable } from '@angular/core';

@Injectable()
export class AppConfig {
    public name = 'Surventis Color Line Monitor';

    public debugMode: boolean = !!window.localStorage.getItem('debugMode');
}
